var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import { LitElement, html, css } from "lit";
import { customElement, property } from "lit/decorators.js";
import { SignalWatcher } from "@lit-labs/preact-signals";
import { draft } from "../state";
const TAGS = ["Pdx", "Adx", "Pproc", "Aproc", "SC", "NC"];
const TAG_LEGEND = {
    Pdx: "Principal diagnosis", Adx: "Additional diagnosis", Pproc: "Principal procedure",
    Aproc: "Additional procedure", SC: "Supplementary chronic-condition code", NC: "Not separately coded",
};
let ModeClassify = class ModeClassify extends SignalWatcher(LitElement) {
    constructor() {
        super(...arguments);
        this.findings = [];
    }
    static { this.styles = css `
    :host, *, *::before, *::after { box-sizing: border-box; }
    :host { display: block; }
    .intro h2 { font-family: var(--font-display); font-size: 13px; font-weight: 700; margin: 0 0 3px;
                text-transform: uppercase; letter-spacing: .05em; color: var(--color-slate-700); }
    .intro .sub { font-size: 12px; color: var(--color-slate-500); margin-bottom: 12px; }
    .legend { display: flex; flex-wrap: wrap; gap: 6px 12px; padding: 10px 12px; background: var(--color-slate-50);
              border: 1px solid var(--color-slate-200); border-radius: var(--radius-md); font-size: 11px;
              color: var(--color-slate-600); margin-bottom: 12px; }
    .legend b { color: var(--color-slate-800); font-family: var(--font-mono); }
    .finding { padding: 12px; border: 1px solid var(--color-slate-200); border-radius: var(--radius-md);
               background: var(--color-white); margin-bottom: 8px; }
    .fhead { display: flex; align-items: baseline; gap: 8px; margin-bottom: 8px; }
    .fbadge { flex: 0 0 auto; font-family: var(--font-mono); font-size: 11px; font-weight: 700;
              color: var(--color-blue-700, #1d4ed8); background: var(--color-blue-100, #dbeafe);
              border-radius: 6px; padding: 2px 7px; letter-spacing: .03em; }
    .ftext { font-size: 13px; line-height: 1.5; color: var(--color-slate-700); }
    .chips { display: flex; gap: 6px; flex-wrap: wrap; }
    .chip { padding: 4px 12px; border-radius: 14px; border: 1px solid var(--color-slate-300);
            background: var(--color-white); color: var(--color-slate-600); cursor: pointer; font: inherit;
            font-size: 12px; font-weight: 600; }
    .chip:hover { border-color: var(--color-blue-500); color: var(--color-blue-600); }
    .chip.selected { background: var(--color-blue-600); color: white; border-color: var(--color-blue-600); }
  `; }
    setTag(fid, tag) {
        const d = draft.value;
        const current = d.classifications ?? {};
        const classifications = { ...current };
        if (classifications[fid] === tag) {
            // clicking the already-selected chip again unselects it (back to unanswered)
            delete classifications[fid];
        }
        else {
            classifications[fid] = tag;
        }
        draft.value = { ...d, classifications };
    }
    render() {
        const cls = draft.value?.classifications ?? {};
        return html `
      <div class="intro">
        <h2>Classify findings</h2>
        <div class="sub">Assign each documented statement to its coding role.</div>
      </div>
      <div class="legend">${TAGS.map((t) => html `<span><b>${t}</b> ${TAG_LEGEND[t]}</span>`)}</div>
      ${this.findings.map((f) => html `
        <div class="finding">
          <div class="fhead">
            <span class="fbadge">${f.id.toUpperCase()}</span>
            <span class="ftext">${f.text}</span>
          </div>
          <div class="chips">
            ${TAGS.map((t) => html `
              <button class="chip ${cls[f.id] === t ? "selected" : ""}"
                      data-fid=${f.id} data-tag=${t}
                      aria-label="Classify as ${t}"
                      @click=${() => this.setTag(f.id, t)}>${t}</button>`)}
          </div>
        </div>`)}
    `;
    }
};
__decorate([
    property({ attribute: false })
], ModeClassify.prototype, "findings", void 0);
ModeClassify = __decorate([
    customElement("mode-classify")
], ModeClassify);
export { ModeClassify };
